module.exports = __webpack_public_path__ + "img/icon_formEdit_movePointer.24525660.svg";